{
	"addBill": "Añadir factura",
	"addBillSuccessNotification": "Cuenta creada correctamente.",
	"addTransfer": "Agregar transferencia",
	"billFields": {
		"account": "Cuenta",
		"accountType": "Tipo de cuenta",
		"category": "Categoría",
		"costCenter": "Centro de coste",
		"description": "Descripción",
		"discount": "Descuento",
		"dueDate": "Fecha de competencia",
		"filename": "exampleOfAccounts",
		"fine": "Multa",
		"interest": "Tarifa",
		"observation": "Comentarios",
		"payDate": "Día de pago",
		"payed": "Pagado?",
		"paymentMethod": "Método de pago",
		"performDate": "Fecha de vencimiento",
		"reconciled": "Reconciliado",
		"supplier": "Proveedor",
		"value": "Valor"
	},
	"competence": "Competencia",
	"dueDate": "Fecha de vencimiento",
	"exportSpreadsheet": "Exportar spreadsheet",
	"importSpreadsheet": "Importar spreadsheet",
	"modalTransfer": {
		"add": "Añadir transferencia",
		"date": "Fecha",
		"description": "Descripción",
		"destinationAccount": "Cuenta de destino",
		"edit": "Modificar transferencia",
		"paid": "Pagado?",
		"sourceAccount": "Cuenta de origen",
		"value": "Valor"
	},
	"printTitle": {
		"any": "Todas las cuentas",
		"default": "Cuentas",
		"toPay": "Cuentas a pagar",
		"toReceive": "Cuentas a recibir",
		"transfer": "Transferencia"
	},
	"printTitleCaps": {
		"any": "TODAS LAS CUENTAS",
		"toPay": "CUENTAS A PAGAR",
		"toReceive": "CUENTAS A RECIBIR",
		"transfer": "TRANSFERENCIAS"
	},
	"tableBill": {
		"account": "Cuenta receptora",
		"description": "Descripción",
		"dueDate": "Fecha de vencimiento",
		"expireToday": "Caduca hoy",
		"expired": "Caducado",
		"notInformed": "No informado",
		"paid": "Pagado?",
		"performDate": "Fecha de competencia",
		"value": "Valor"
	},
	"tableTransfer": {
		"actions": "Opciones",
		"date": "Fecha",
		"description": "Descripción",
		"destinationAccount": "Cuenta de destino",
		"paid": "Pagado?",
		"popConfirm": "¿Está seguro de que desea eliminar esta transferencia?",
		"sourceAccount": "Cuenta de origen",
		"value": "Valor"
	}
}
